import {register, CloudObject, defineProperty, Direction, Relation} from 'olympe';
import {of} from "rxjs";
import {JSONPath} from "jsonpath-plus";

/**
 * @extends {CloudObject}
 */
export default class DatagridColumnConfig extends CloudObject {

    /**
     * Resolve each time the object changes
     * @return {!Observable<!Object>}
     */
    observeObject() {
        const toObject = () => ({
            tag: this.getTag(),
            [DatagridColumnConfig.propertyProp.getTag()]: this.get(DatagridColumnConfig.propertyProp) || '',
            [DatagridColumnConfig.headerProp.getTag()]: this.get(DatagridColumnConfig.headerProp) || '',
            [DatagridColumnConfig.columnWidthProp.getTag()]: this.get(DatagridColumnConfig.columnWidthProp) || 1,
            [DatagridColumnConfig.rendererTypeProp.getTag()]: this.get(DatagridColumnConfig.rendererTypeProp) || 'STRING',
            [DatagridColumnConfig.rendererOptionsProp.getTag()]: parseJSON(this.get(DatagridColumnConfig.rendererOptionsProp)),
            [DatagridColumnConfig.columnOptionsProp.getTag()]: parseJSON(this.get(DatagridColumnConfig.columnOptionsProp)),
            [DatagridColumnConfig.rankProp.getTag()]: this.get(DatagridColumnConfig.rankProp) || 0,
            [DatagridColumnConfig.sortableProp.getTag()]: this.get(DatagridColumnConfig.sortableProp) || false,
        });
        return of(toObject());
    }
}

// Hardcoded tags
register('0192723393783f87d46f', DatagridColumnConfig);
DatagridColumnConfig.propertyProp = defineProperty('019272341052d7248f96');
DatagridColumnConfig.headerProp = defineProperty('0192723426c7f010659f');
DatagridColumnConfig.columnWidthProp = defineProperty('0192723448f7884d4e7f');
DatagridColumnConfig.rendererTypeProp = defineProperty('0192723468ca26c8a012');
DatagridColumnConfig.rendererOptionsProp = defineProperty('0192723483c5a82df7e6');
DatagridColumnConfig.rankProp = defineProperty('01927234ab0e106ecbb9');
DatagridColumnConfig.columnOptionsProp = defineProperty('01927234c0fd23f5c45b');
DatagridColumnConfig.sortableProp = defineProperty('01927234ed0562a726d4');


/**
 * Try to parse a JSON string a return it's javascript representation.
 * Returns an empty object if the parse fails
 *
 * @param {string} json
 * @return {*}
 */
function parseJSON(json) {
    let object = {};
    try {
        object = JSON.parse(json);
    } catch (e) {}
    return object;
}

/**
 * @param {!CloudObject} object
 * @param {string} paths
 * @return {!Array}
 */
export function getValuesFromPaths(object, paths) {
    return paths
            .split(';')
            .map((path) =>
                path
                    .split('::')
                    .map((subpath) => subpath.trim())
                    .filter((subpath) => subpath)
            )
            .filter((path) => path.length > 0)
            .map((path) => getValueFromPath(object, path));
}

/**
 * @param {!CloudObject} object
 * @param {!Array} path
 * @return {!*}
 */
function getValueFromPath(object, path) {
    if(object instanceof CloudObject) {
        let finalObject = object;
        for (let i = 0; i < path.length - 1; i++) {
            if (!finalObject) break;
            const relationObject = findRelationFromName(finalObject, path[i]);
            const relation = new Relation(relationObject.getTag(), Direction.DESTINATION);
            finalObject = finalObject.followSingle(relation).executeFromCache();
        }
        return finalObject?.get(findPropertyFromName(finalObject, path[path.length - 1]));
    } else {
        const result = JSONPath(path[0], object);
        if (Array.isArray(result)) {
            return result[0];
        } else {
            return undefined;
        }
    }
}

/**
 * @param {!CloudObject} object
 * @param {string} name
 * @return {!Property}
 */
function findPropertyFromName(object, name) {
    const properties = object.getModel().follow(CloudObject.propertyRel).executeFromCache();
    const inheritedProperties = object
        .getModel()
        .follow(CloudObject.extendRel, true)
        .follow(CloudObject.propertyRel)
        .executeFromCache();

    for (const property of properties.values()) {
        if (property.name() === name) {
            return property;
        }
    }

    for (const property of inheritedProperties.values()) {
        if (property.name() === name) {
            return property;
        }
    }
    return null;
}

/**
 * @param {!CloudObject} object
 * @param {string} name
 * @return {Relation}
 */
function findRelationFromName(object, name) {
    const originOfRelationRel = new Relation('ff02200000000000000a', Direction.DESTINATION);
    const relations = object.getModel().follow(originOfRelationRel).executeFromCache();
    for (const relation of relations.values()) {
        if (relation.name() === name) {
            return relation;
        }
    }
    return null;
}

export const getRidOfCommas = (num) => {
    let res = num;

    // if num is a string which would be a valid number if the commas were deleted
    if (typeof num === 'string') {
        const noCommas = num.replace(/,/g, '.');
        if (!isNaN(noCommas)) {
            res = Number(noCommas);
        }
    }
    return res;
};